import React from 'react';

import style from './ExitScreen.css';
import { buildAssetUrl } from '../../helpers';

const ExitScreenComponent = ({ exitScreen, exitClick }) => {
  const htmlOptions = {
    createYourOwn: (
      <div className={style.exitHtml}>
        <div className={style.button}> Create Your Own</div>
        <div> on </div>
        <img src={buildAssetUrl('assets/images/logos/ayvri-logo-color.svg')} alt='ayvri' />
      </div>
    ),
  };

  return (
    <div className={style.exitScreen}>
      {exitScreen.map(item => (
        <div key={item.link} className={style.exitItem} onClick={() => exitClick(item.link)}>
          {item.component ? htmlOptions[item.component] : <img src={item.image} alt={item.link} />}
        </div>
      ))}
    </div>
  );
};

export default ExitScreenComponent;
